import _extends from "@babel/runtime/helpers/extends";
import Box from "@material-ui/core/esm/Box";
import clsx from 'clsx';
import React from 'react';
import { Info } from 'components/Text';
import useStyles from './InfoBoxStyles';
export default function InfoBox({
  children,
  className,
  warning,
  ...rest
}) {
  const {
    box,
    infoBox,
    warningBox
  } = useStyles();
  return /*#__PURE__*/React.createElement(Box, _extends({
    className: clsx(box, className, {
      [warningBox]: warning,
      [infoBox]: !warning
    })
  }, rest), /*#__PURE__*/React.createElement(Info, null, children));
}
InfoBox.defaultProps = {
  className: '',
  warning: false
};